import { LIMOUSINE } from "./limousine";
import { PRIVATE_JET } from "./privateJet";
import { TRAVEL_TOURISM } from "./travelAndTourism";
import { CAR_RENTAL } from "./carRental";
import { COMMERCIAL_BROKER } from "./commercial";
import { ECOMMERCE } from "./ecommerce";

export const InvestmentData = {
    Investments: [
        { key: "LIMOUSINE", title: "LIMOUSINE", icon: "/img/investments/limousine.svg" },
        { key: "PRIVATE_JET", title: "PRIVATE JET", icon: "/img/investments/private-jet.svg" },
        { key: "TRAVEL_TOURISM", title: "TRAVEL & TOURISM", icon: "/img/investments/travel.svg" },
        { key: "CAR_RENTAL", title: "CAR RENTAL", icon: "/img/investments/car-rental.svg" },
        { key: "COMMERCIAL_BROKER", title: "COMMERCIAL BROKER", icon: "/img/investments/broker.svg" },
        { key: "ECOMMERCE", title: "ECOMMERCE", icon: "/img/investments/ecommerce.svg" },
    ],
    LIMOUSINE,
    PRIVATE_JET,
    TRAVEL_TOURISM,
    CAR_RENTAL,
    COMMERCIAL_BROKER,
    ECOMMERCE
};
